import React from "react";
import { observer } from "mobx-react";
import { ProvinceStateCreateStore } from "../../store";
import { ProvinceStateCreateForm } from "./ProvinceStateCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ProvinceStateCreateProps = {
  provinceStateCreateStore: ProvinceStateCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ProvinceStateCreate: React.FC<ProvinceStateCreateProps> = observer(
  ({ provinceStateCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={provinceStateCreateStore.isSaving} />
        <ProvinceStateCreateForm
          provinceStateCreateStore={provinceStateCreateStore}
          name_esError={provinceStateCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            provinceStateCreateStore.setName_esValue(value);
          }}
          name_es={provinceStateCreateStore.entityValues.name_es}
          name_enError={provinceStateCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            provinceStateCreateStore.setName_enValue(value);
          }}
          name_en={provinceStateCreateStore.entityValues.name_en}
          name_ptError={provinceStateCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            provinceStateCreateStore.setName_ptValue(value);
          }}
          name_pt={provinceStateCreateStore.entityValues.name_pt}
          countryError={provinceStateCreateStore.errors.country?.message}
          onCountryChange={(value) => {
            provinceStateCreateStore.setCountryValue(value);
          }}
          countrySelectedValue={
            provinceStateCreateStore.entityValues.showCountry
          }
          onCountrySelected={(value) => {
            provinceStateCreateStore.setSelectedCountry(value);
          }}
          countryOptions={provinceStateCreateStore.getCountryOptions()}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={provinceStateCreateStore.isProcessing}
          onSave={() => provinceStateCreateStore.saveNewProvinceState()}
          onCancel={() => provinceStateCreateStore.cancelNewProvinceState()}
        />
        <ErrorDialog
          open={provinceStateCreateStore.errorDialogOpened}
          title={provinceStateCreateStore.errorTitle}
          description={provinceStateCreateStore.errorDescription}
          onClose={() => provinceStateCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
